module.exports = __webpack_public_path__ + "static/img/technology02.6b79b657.png";